import { createSlice , createSelector} from "@reduxjs/toolkit";
import API from "../../services/api";
import { SURVEYS_API_URL } from "../../config/service";
import { showError, showSuccess } from "../messages/messagesSlice";


export const surveyRequestSlice = createSlice({
    name: 'surveyrequestdata',
    initialState:{
        requestMessage: false,
        surveyrequestdata: [],
        adminsurveyrequestdata: [],
        updateRequest: false,
    },
    reducers:{
        setrequestStatus: ( state, action)=>{
            if(action.payload){
                state.requestMessage= action.payload;
            }

        },
        setSurveyRequestData: (state, action)=>{
            if (action.payload) {
                state.surveyrequestdata = action.payload;
            }
        },
        setAdminSurveyRequestData: (state, action) =>{
            if (action.payload){
                state.adminsurveyrequestdata = action.payload;
            }
        }
        ,
        setUpdatedRequest: (state, action) =>{
            state.updateRequest = action.payload;
        }
    }
});

export const { setrequestStatus, setSurveyRequestData, setAdminSurveyRequestData, setUpdatedRequest }= surveyRequestSlice.actions;

export const surveyRequest = (surveyString, adminEmails, surveyTitle, adminNames) => dispatch => {
    try{  
        API.post(`${SURVEYS_API_URL}/v1/surveys/request`,{
            surveyString: surveyString,
            adminList: adminEmails,
            surveyTitle: surveyTitle,
            adminNames: adminNames,
        }).then((response)=>{
            dispatch(showSuccess({"message": "You have succesfully requested the survey."}));
            dispatch(getSurveyRequests()); 
            dispatch(setrequestStatus(true));
        })
    }
    catch(error){
        dispatch(showError({ "message": `Failed to send Survey Request ${error.response.data.message}`}));
    }

}

export const getSurveyRequests = () => async (dispatch) => {
    try {
        const response = await API.get(`${SURVEYS_API_URL}/v1/surveys/request/user`);        
        dispatch(setSurveyRequestData(response.data.Items)); 
    } catch (error) {        
        dispatch(
            showError({
                message: `Failed to fetch surveys requested: ${
                    error.response?.data?.message || error.message
                }`
            })
        );
    }
};

export const getAdminsSurveyRequests = () => async (dispatch) =>{
    try{
        API.get(`${SURVEYS_API_URL}/v1/surveys/request/admins`)
        .then((response)=>{dispatch(setAdminSurveyRequestData(response.data))});
    } catch (error){
        dispatch(showError({"message":`Failed to fetch admin surveys requests ${error.response.data.message}`}));
    }

}

export const updateSurveyRequest = (updatedRecord) => async (dispatch) =>{
    try{
    API.put (`${SURVEYS_API_URL}/v1/surveys/request/status`,{
        updatedRecord: updatedRecord,
    }).then((response)=>{
        dispatch(showSuccess({"message": "You have succesfully updated the survey request."}));
        dispatch(getAdminsSurveyRequests());
        dispatch(setUpdatedRequest(true))});
    } catch (error){
        dispatch(showError({"message":`Failed to update surveys status ${error.response.data.message}`}));
    }
}
export const selectSurveyRequest = createSelector(
    [(state) => state.surveyrequestdata.surveyrequestdata],  // Adjust to your actual state path
    (surveyrequestdata) => surveyrequestdata || []
  );
export const selectAdminSurveyRequest = (state) => state.surveyrequestdata.adminsurveyrequestdata;
export const selectRequestSuccess =(state) => state.surveyrequestdata.requestMessage;

export default surveyRequestSlice.reducer;